import { render, staticRenderFns } from "./SupportGames.vue?vue&type=template&id=2c06312d&scoped=true&"
import script from "./SupportGames.vue?vue&type=script&lang=js&"
export * from "./SupportGames.vue?vue&type=script&lang=js&"
import style0 from "./SupportGames.vue?vue&type=style&index=0&id=2c06312d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c06312d",
  null
  
)

/* custom blocks */
import block0 from "./SupportGames.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports